import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import TeacherResultsEntry from './pages/TeacherResultsEntry';
import ResultsSummary from './pages/ResultsSummary';
import TeacherExams from './pages/TeacherExams';
import StudentResults from './pages/StudentResults';
import StudentProfile from './pages/StudentProfile';
import StudentExams from './pages/StudentExams';
import StudentFeePayments from './pages/StudentFeePayments';
import AdminStudents from './pages/admin/AdminStudents';
import AdminExams from './pages/admin/AdminExams';
import AdminTeachers from './pages/admin/AdminTeachers';
import AdminClasses from './pages/admin/AdminClasses';
import AdminSubjects from './pages/admin/AdminSubjects';
import AdminFundCollectors from './pages/admin/AdminFundCollectors';
import FundCollectorDashboard from './pages/fundcollector/FundCollectorDashboard';
import ManageArrears from './pages/fundcollector/ManageArrears';
import PaymentHistory from './pages/fundcollector/PaymentHistory';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/teacher/results-entry"
              element={
                <PrivateRoute>
                  <TeacherResultsEntry />
                </PrivateRoute>
              }
            />
            <Route
              path="/teacher/exams"
              element={
                <PrivateRoute>
                  <TeacherExams />
                </PrivateRoute>
              }
            />
            <Route
              path="/teacher/results-summary"
              element={
                <PrivateRoute>
                  <ResultsSummary />
                </PrivateRoute>
              }
            />
            <Route
              path="/student/results"
              element={
                <PrivateRoute>
                  <StudentResults />
                </PrivateRoute>
              }
            />
            <Route
              path="/student/profile"
              element={
                <PrivateRoute>
                  <StudentProfile />
                </PrivateRoute>
              }
            />
            <Route
              path="/student/exams"
              element={
                <PrivateRoute>
                  <StudentExams />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/students"
              element={
                <PrivateRoute>
                  <AdminStudents />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/exams"
              element={
                <PrivateRoute>
                  <AdminExams />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/teachers"
              element={
                <PrivateRoute>
                  <AdminTeachers />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/classes"
              element={
                <PrivateRoute>
                  <AdminClasses />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/subjects"
              element={
                <PrivateRoute>
                  <AdminSubjects />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/fund-collectors"
              element={
                <PrivateRoute>
                  <AdminFundCollectors />
                </PrivateRoute>
              }
            />
            <Route
              path="/student/fee-payments"
              element={
                <PrivateRoute>
                  <StudentFeePayments />
                </PrivateRoute>
              }
            />
            <Route
              path="/fund-collector/dashboard"
              element={
                <PrivateRoute>
                  <FundCollectorDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/fund-collector/arrears"
              element={
                <PrivateRoute>
                  <ManageArrears />
                </PrivateRoute>
              }
            />
            <Route
              path="/fund-collector/payment-history"
              element={
                <PrivateRoute>
                  <PaymentHistory />
                </PrivateRoute>
              }
            />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
